<!-- sections/DisplayTypeSection.vue -->
<script setup lang="ts">
import { computed } from 'vue';
import BaseSection from '../components/BaseSection.vue';
import { chartIconMap } from '@/lib/chart-helpers';
import ConnxIcon from '@/components/Atoms/ConnxIcon.vue';
import type { DashboardWidget } from '@/interfaces/Dashboard';

interface Props {
  widget: DashboardWidget;
  availableTypes: string[];
  showTitle?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  showTitle: true,
});

const emit = defineEmits<{
  'update:display-type': [type: string];
}>();

const displayTypes = computed(() => {
  const availableTypes = props.availableTypes?.map((t) => t.toLowerCase()) || [];
  return Array.from(chartIconMap.entries()).filter(([type]) => availableTypes.includes(type));
});

const setCurrentDisplayType = (type: string) => {
  emit('update:display-type', type);
};

const isSelected = (type: string) => {
  const currentType = props.widget.defaultJsonProperties.currentDisplayType;
  const isTable = props.widget.defaultJsonProperties.displayedAsTable;

  return (currentType === type && !isTable) || (isTable && type === 'table');
};
</script>

<template>
  <BaseSection title="Visual Type" :should-show="displayTypes.length > 0" :show-title="showTitle">
    <div class="tw-flex tw-gap-4 tw-flex-wrap tw-justify-start tw-pb-4">
      <button
        v-for="[type, icon] in displayTypes"
        :title="icon.label"
        :key="type"
        @click="setCurrentDisplayType(type)"
        class="tw-background-transparent tw-outline-none tw-w-20 tw-h-20 tw-rounded-md tw-border tw-border-solid tw-flex tw-items-center tw-justify-center hover:tw-text-connx-primary hover:tw-border-connx-primary hover:tw-border-2"
        :class="
          isSelected(type)
            ? 'tw-border-connx-primary tw-text-connx-primary tw-border-2'
            : 'tw-border-connx-grey-tint-70 tw-text-connx-grey-tint-70'
        "
      >
        <connx-icon :name="icon.icon" :class="icon.class" class="tw-w-12 tw-h-auto"></connx-icon>
      </button>
    </div>
  </BaseSection>
</template>
